import { render, staticRenderFns } from "./classComparison.vue?vue&type=template&id=355cbe0a&scoped=true"
import script from "./classComparison.vue?vue&type=script&lang=js"
export * from "./classComparison.vue?vue&type=script&lang=js"
import style0 from "./classComparison.vue?vue&type=style&index=0&id=355cbe0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355cbe0a",
  null
  
)

export default component.exports